export const ROLES = {
  ADMIN: "admin",
  RRHH: "rrhh",
  CONTABILIDAD: "contabilidad",
  SUPERVISOR: "supervisor",
  ASESOR: "asesor",
  ASESOR_CHAT: "asesor_chat",
  ASESOR_LIDER: "asesor_lider",
  ASESOR_CORPORATIVO: "asesor_corporativo",
  ASESOR_LIDER_CORPORATIVO: "asesor_lider_corporativo"
}
